import { useRef } from 'react';

let idCounter = 0;

/**
 * Generates a unique ID for components.
 * Compatible with React < 18 (useId was introduced in React 18, but may not be available in all versions)
 */
export function useId(): string {
  const idRef = useRef<string | null>(null);

  if (idRef.current === null) {
    idRef.current = `:r${++idCounter}:`;
  }

  return idRef.current;
}
